import * as React from "react";
import { cn } from "@/lib/utils";

const DOMAIN_COLORS: Record<string, string> = {
  software:
    "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-400/15 dark:text-sky-300 dark:border-sky-400/25",
  devices:
    "bg-amber-100 text-amber-900 border-amber-200 dark:bg-amber-400/15 dark:text-amber-300 dark:border-amber-400/25",
  medical:
    "bg-rose-100 text-rose-800 border-rose-200 dark:bg-rose-400/15 dark:text-rose-300 dark:border-rose-400/25",
};

const FALLBACK = "bg-muted text-muted-foreground border-border";

export function Badge({
  domainSlug,
  className,
  children,
  ...props
}: React.ComponentProps<"span"> & { domainSlug?: string }) {
  const color = domainSlug ? DOMAIN_COLORS[domainSlug] ?? FALLBACK : FALLBACK;
  return (
    <span
      data-slot="badge"
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        color,
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
